import useColorMode from "../../hooks/useColorMode";

const DarkModeSwitcher = () => {
  const [colorMode, setColorMode] = useColorMode();

  return (
    <li>
      <label
        className={`relative m-0 block h-8 w-16 rounded-full transition-colors duration-300 ${
          colorMode === "dark" ? "bg-primary" : "bg-stroke"
        }`}
      >
        <input
          type="checkbox"
          onChange={() => {
            if (typeof setColorMode === "function") {
              setColorMode(colorMode === "light" ? "dark" : "light");
            }
          }}
          className="absolute top-0 left-0 z-50 h-full w-full cursor-pointer opacity-0"
        />
        <span
          className={`shadow-switcher absolute top-1/2 left-2 flex h-6 w-6 -translate-y-1/2 transform items-center justify-center rounded-full bg-white transition-transform duration-300 ease-in-out ${
            colorMode === "dark" ? "translate-x-full" : ""
          }`}
        >
          <span className="flex items-center justify-center dark:hidden">
            <i className="fa-solid fa-sun text-gray-500"></i>
          </span>
          <span className="hidden items-center justify-center dark:flex">
            <i className="fa-solid fa-moon text-gray-500"></i>
          </span>
        </span>
      </label>
    </li>
  );
};

export default DarkModeSwitcher;
